import { Currency, CurrencyAmount, currencyEquals, ETHER, Token } from '@pancakeswap-libs/sdk-v2'
import React, { CSSProperties, MutableRefObject, useCallback, useMemo } from 'react'
import { NavLink } from 'react-router-dom'
import { FixedSizeList } from 'react-window'
import styled from 'styled-components'
import { Text } from '@pancakeswap-libs/uikit'
import Logo from 'components/Logo'
import { TranslateString } from 'utils/translateTextHelpers'
import Column from './Column'
import { RowFixed } from './Row'
// import CurrencyLogo from '../CurrencyLogo'
import {  MenuItem, LinkStyledButton } from './styleds'
import { SelectItem } from './ItemInter'



const Image = styled(Logo)`
  height: 24px;
  width: auto;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  vertical-align: middle;
`

const StyledMenuItem = styled(MenuItem)`
  grid-template-columns: auto minmax(auto,1fr) auto minmax(0,0px);
`

function renderName (n) {
  if (n?.length >=25) {
    return `${n.substring(0, 22)}...`;
  }
  return n;
}

function OptionRow({
  option,
  onSelect,
  style,
}: {
  option: any
  onSelect: () => void
  style: CSSProperties
}) {
  const name = option.name
  // only show add or remove buttons if not on selected list
  return (
    <StyledMenuItem
      style={style}
      className={`option-item-${name}`}
      onClick={() => onSelect()}
    >
      {/* add text id */}
      {
         option?.textId?
         <>
            <Image srcs={[option.image, "/images/UNKNOWNSEP20.png"]} alt={`${TranslateString(option.textId,name)} Logo`} />
            <Column>
              <Text title={TranslateString(option.textId,name)}>
                {renderName(TranslateString(option.textId,name))}
              </Text>
            </Column>
         </>
         :
         <>
            <Image srcs={[option.image, "/images/UNKNOWNSEP20.png"]} alt={`${name} Logo`} />
            <Column>
              <Text title={option.name}>
                {renderName(option.name)}
              </Text>
            </Column>
         </>
      }
      {/* <Image srcs={[option.image, "/images/UNKNOWNSEP20.png"]} alt={`${name} Logo`} />
      <Column>
        <Text title={option.name}>
          {renderName(option.name)}
        </Text>
      </Column> */}
    </StyledMenuItem>
  )
}

export default function CurrencyList({
  height,
  options,
  onSelect,
}: {
  height: number
  options: any[]
  onSelect: (currency: SelectItem) => void
}) {
  const itemData = options
  const Row = useCallback(
    ({ data, index, style }) => {
      const option: SelectItem = data[index]
      const handleSelect = () => onSelect(option)
      return (
        <OptionRow
          key={`select_option_${(option as any).id}`}
          style={style}
          option={{...option}}
          onSelect={handleSelect}
        />
      )
    },
    // eslint-disable-next-line
    []
  )

  return (
    <FixedSizeList
      height={height}
      itemCount={itemData.length}
      itemSize={56}
      itemData={itemData}
      width='100%'
    >
      {Row}
    </FixedSizeList >
  )
}
